var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { open: _vm.open, listening: _vm.listening },
      attrs: { id: "hey-supsis" },
    },
    [
      _vm.commandProcessing
        ? _c("span", { staticClass: "message" }, [_vm._v(_vm._s(_vm.command))])
        : _c("span", { staticClass: "message" }, [_vm._v(_vm._s(_vm.message))]),
      _vm._v(" "),
      _vm.commandProcessing
        ? _c(
            "div",
            { staticClass: "rotating-border rotating-border--rainbow" },
            [_c("MicButton", { attrs: { active: _vm.listening } })],
            1
          )
        : _c("MicButton", { attrs: { active: _vm.listening } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }